import { styled } from '@classify/react-core-components/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Stack from '@classify/react-core-components/Stack';
import Typography from '@classify/react-core-components/Typography';
import Button from '@classify/react-core-components/Button';

import { SHOULD_DISPLAY_MAINTENANCE_BANNER } from '../../constants/maintenanceStaticContent';
import useBlueshiftLiveContent from '../../hooks/useBlueshiftLiveContent';
import { SlotNames } from '../../constants/blueshift';

const BannerWrapper = styled('div')(({ theme: { palette, spacing, zIndex, breakpoints } }) => ({
  display: 'none',
  padding: spacing(2, 0, 1, 0),
  backgroundColor: SHOULD_DISPLAY_MAINTENANCE_BANNER
    ? palette.notification.warning.background
    : palette.brand.accent.option1,
  position: 'relative',
  zIndex: zIndex.appBar,
  [breakpoints.up('sm')]: {
    display: 'block',
    padding: spacing(1, 0),
  },
}));

const BannerButton = styled(Button)(({ theme: { palette } }) => ({
  '&, &:hover, &:focus': {
    color: palette.text.onMain,
  },
  '&:hover:not(:active), &:focus': {
    backgroundColor: SHOULD_DISPLAY_MAINTENANCE_BANNER
      ? palette.interaction.onSelected
      : palette.interaction.onContrasted.hover,
  },
}));

const PredictiveCRMTopBanner = () => {
  const { liveContent } = useBlueshiftLiveContent(SlotNames.TopBanner);

  if (!liveContent) {
    return null;
  }

  const { content } = liveContent;

  if (!content.dataEvent) {
    return null;
  }

  const { type, category, action, label: dataEventLabel } = content.dataEvent;

  return (
    <BannerWrapper>
      <ContentWrapper>
        <Stack
          flexDirection={{ sm: 'row' }}
          flexWrap="wrap"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body" sx={{ py: 1, px: { xs: 2, md: 0 } }}>
            {content.body}
          </Typography>
          {content?.button && (
            <BannerButton
              variant="tertiary"
              href={content.link}
              data-event={type ? `${type}|${category}|${action}|${dataEventLabel}` : null}
              target={content.isTargetBlankLink ? '_blank' : null}
            >
              {content.button}
            </BannerButton>
          )}
        </Stack>
      </ContentWrapper>
    </BannerWrapper>
  );
};

export default PredictiveCRMTopBanner;
